import React, {lazy, Suspense, useContext} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import LoadingSuspense from './components/common/LoadingSuspense';
import {
    AFFILIATE_LOGIN_PATH,
    BKASH_PAYMENT_COMPLETED_PATH,
    BKASH_PAYMENT_FAILED_PATH,
    BKASH_PAYMENT_SUCCESS_PATH,
    LOGIN_PATH,
    OTP_PATH,
    PAGE_403_PATH,
    PAGE_404_PATH,
    PAGE_500_PATH,
    PMS_LOGIN_PATH,
    PMS_PHARMACY_VIEW_PATH,
    PMS_TERMS_CONDITION_APP_PATH,
    PRODUCT_INSERT_BKASH_PAYMENT_FAILED_PATH,
    PRODUCT_INSERT_BKASH_PAYMENT_SUCCESS_PATH,
    ROOT_PATH,
    SIGN_UP_PATH, SMS_PAYMENT_FAILED_PATH, SMS_PAYMENT_SUCCESS_PATH,
    VERIFY_PHARMACY_INFO_PATH
} from './routes/Slugs';
import PrivateRoute from './components/common/PrivateRoute';
import {AuthContext} from './contexts/AuthContextProvider';
import Acl from './Acl';
import * as ReactGA from "react-ga";
import {AffiliateAuthContext} from "./contexts/AffiliateAuthContextProvider";

const SignUp = lazy(() => import("./components/pages/pms/auth/SignUp"));
const OTPVerification = lazy(() => import("./components/pages/pms/auth/OtpVerification"));
const VerifyPharmacyInfo = lazy(() => import("./components/pages/pms/auth/verify_pharmacy/VerifyPharmacyInfo"));

const AffiliateLogin = lazy(() => import('./components/pages/affiliator/login/AffiliateLoginPage'));
const DefaultLayout = lazy(() => import('./components/layout/DefaultLayout'));
const DefaultLAffiliateayout = lazy(() => import('./components/layout/DefaultLAffiliateayout'));
const WrappedLogin = lazy(() => import('./components/pages/os/login/Login'));
const PMSLoginPage = lazy(() => import("./components/pages/pms/login/PMSLoginPage"));
const PMSPharmacy = lazy(() => import("./components/pages/pms/pharmacy/PMSPharmacy"));
const Page403 = lazy(() => import('./components/pages/os/error_pages/Page403'));
const Page404 = lazy(() => import('./components/pages/os/error_pages/Page404'));
const Page500 = lazy(() => import('./components/pages/os/error_pages/Page500'));

const PMSTermsAndConditions = lazy(() => import("./components/pages/terms_conditions/PMSTermsConditions"));

const PMSPaymentSuccess = lazy(() => import("./components/pages/pms/success_page/BkashPaymentSuccess"));
const PMSPaymentFailed = lazy(() => import("./components/pages/pms/success_page/BkashPaymentFailed"));

const PMSProductInsertaymentSuccess = lazy(() => import("./components/pages/pms/success_page/ProductInsertBkashPaymentSuccess"));
const PMSPaymentCompleted = lazy(() => import("./components/pages/pms/success_page/BkashPaymentCompleted"));
const PMSPProductInsertaymenPMSPaymentFailed = lazy(() => import("./components/pages/pms/success_page/PrductInsertBkashPaymentFailed"));

const SmsPaymentSuccess = lazy(() => import("./components/pages/pms/success_page/SmsPaymentSuccess"));
const SmsPaymentFailed = lazy(() => import("./components/pages/pms/success_page/SmsPaymentFailed"));

const App = () => {

    const authContext = useContext(AuthContext);
    const affiliateAuthContext = useContext(AffiliateAuthContext);

    ReactGA.initialize('G-23F7CG8KX5');
    ReactGA.pageview(window.location.pathname + window.location.search);

    return (
        <div className="app_wrapper">
            <Suspense fallback={<LoadingSuspense height={"100vh"}/>}>
                <BrowserRouter>

                    <Switch>
                        <Route exact path={SIGN_UP_PATH} component={SignUp}/>
                        <Route exact path={OTP_PATH} component={OTPVerification}/>
                        <Route exact path={VERIFY_PHARMACY_INFO_PATH} component={VerifyPharmacyInfo}/>
                        <Route exact path={AFFILIATE_LOGIN_PATH} component={AffiliateLogin}/>
                        <Route exact path={LOGIN_PATH} component={WrappedLogin}/>
                        <Route exact path={PMS_LOGIN_PATH} component={PMSLoginPage}/>
                        <Route exact path={PMS_TERMS_CONDITION_APP_PATH} component={PMSTermsAndConditions}/>
                        <Route exact path={BKASH_PAYMENT_SUCCESS_PATH} component={PMSPaymentSuccess}/>
                        <Route exact path={BKASH_PAYMENT_FAILED_PATH} component={PMSPaymentFailed}/>

                        <Route exact path={PRODUCT_INSERT_BKASH_PAYMENT_SUCCESS_PATH}
                               component={PMSProductInsertaymentSuccess}/>
                        <Route exact path={BKASH_PAYMENT_COMPLETED_PATH} component={PMSPaymentCompleted}/>
                        <Route exact path={PRODUCT_INSERT_BKASH_PAYMENT_FAILED_PATH}
                               component={PMSPProductInsertaymenPMSPaymentFailed}/>


                        <PrivateRoute isLogin={authContext.isLogin} path={SMS_PAYMENT_SUCCESS_PATH}
                                      component={SmsPaymentSuccess}/>
                        <PrivateRoute isLogin={authContext.isLogin} path={SMS_PAYMENT_FAILED_PATH}
                                      component={SmsPaymentFailed}/>

                        <PrivateRoute isLogin={authContext.isLogin} exact path={PAGE_404_PATH} component={Page404}/>
                        <PrivateRoute isLogin={authContext.isLogin} exact path={PAGE_403_PATH} component={Page403}/>
                        <PrivateRoute isLogin={authContext.isLogin} exact path={PAGE_500_PATH} component={Page500}/>
                        {authContext.isAffiliator &&
                            <PrivateRoute isLogin={authContext.isLogin} path={ROOT_PATH}
                                          component={DefaultLAffiliateayout}/>
                        }
                        <PrivateRoute isLogin={authContext.isLogin} path={PMS_PHARMACY_VIEW_PATH}
                                      component={PMSPharmacy}/>
                        <PrivateRoute isLogin={authContext.isLogin} path={ROOT_PATH} component={DefaultLayout}/>
                    </Switch>
                    <Acl/>
                </BrowserRouter>

            </Suspense>
        </div>
    );

}

export default App;
